(function () {
  if (window.__t4sPromoSessionBound) return;
  window.__t4sPromoSessionBound = true;

  var CACHE_PREFIX = 't4s_promo_map_v4_';
  var CACHE_TTL_MS = 30 * 60 * 1000;
  var probePromise = null;
  var probing = false;

  function formatMoney(cents) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = Number(cents);
    if (isNaN(cents)) return '';

    var formatString =
      (window.T4SPromoBoot && window.T4SPromoBoot.moneyFormat) ||
      (window.T4Sconfigs && window.T4Sconfigs.moneyFormat) ||
      (window.Shopify && window.Shopify.money_format) ||
      '${{amount}}';

    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var match = formatString.match(placeholderRegex);
    if (!match) return String(cents / 100);

    function withDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      var num = (number / 100).toFixed(precision);
      var parts = num.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }

    var value = '';
    switch (match[1]) {
      case 'amount':
        value = withDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = withDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = withDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = withDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = withDelimiters(cents, 2, "'", '.');
        break;
      default:
        value = withDelimiters(cents, 2);
    }
    return formatString.replace(placeholderRegex, value);
  }

  function uniqCodes(list) {
    var out = [];
    (list || []).forEach(function (code) {
      if (!code) return;
      code = String(code).toUpperCase().trim();
      if (code && out.indexOf(code) === -1) out.push(code);
    });
    return out;
  }

  function codeFromCookie() {
    try {
      var match = document.cookie.match(/(?:^|; )discount_code=([^;]*)/);
      if (!match) return '';
      return decodeURIComponent(match[1]).replace(/^"|"$/g, '').trim();
    } catch (e) {
      return '';
    }
  }

  function codeFromPath() {
    // /discount/CODE redirects away and stores the code in the discount_code cookie.
    var m = (location.pathname || '').match(/\/discount\/([^\/\?\#]+)/i);
    if (m) return decodeURIComponent(m[1]);
    return codeFromCookie();
  }

  function readCache(code) {
    try {
      var raw = JSON.parse(sessionStorage.getItem(CACHE_PREFIX + code) || 'null');
      if (!raw || typeof raw !== 'object' || !raw.map || typeof raw.map !== 'object') return {};
      if (!raw.t || Date.now() - Number(raw.t) > CACHE_TTL_MS) {
        sessionStorage.removeItem(CACHE_PREFIX + code);
        return {};
      }
      return raw.map;
    } catch (e) {
      return {};
    }
  }

  function writeCache(code, map) {
    try {
      var key = CACHE_PREFIX + code;
      var t = Date.now();
      var prev = JSON.parse(sessionStorage.getItem(key) || 'null');
      if (prev && prev.t && Date.now() - Number(prev.t) <= CACHE_TTL_MS) t = Number(prev.t);
      sessionStorage.setItem(key, JSON.stringify({ t: t, map: map || {} }));
    } catch (e) {}
  }

  var silentWinReady = null;
  function getSilentWin() {
    if (silentWinReady) return silentWinReady;
    silentWinReady = new Promise(function (resolve) {
      var iframe = document.createElement('iframe');
      iframe.name = 't4s-promo-silent';
      iframe.setAttribute('aria-hidden', 'true');
      iframe.tabIndex = -1;
      iframe.style.cssText =
        'position:absolute;width:0;height:0;border:0;opacity:0;pointer-events:none;left:-9999px';
      iframe.addEventListener('load', function () {
        resolve(iframe.contentWindow);
      });
      iframe.src = 'about:blank';
      document.documentElement.appendChild(iframe);
    });
    return silentWinReady;
  }

  function silentFetch(url, options) {
    return getSilentWin().then(function (win) {
      return win.fetch(url, options || { credentials: 'same-origin' }).then(function (r) {
        return r
          .json()
          .catch(function () {
            return {};
          })
          .then(function (data) {
            if (!data || typeof data !== 'object') data = {};
            data.__ok = r.ok;
            data.__status = r.status;
            return data;
          });
      });
    });
  }

  function fetchCart() {
    return silentFetch('/cart.js', { credentials: 'same-origin' });
  }

  function postJson(url, body) {
    return silentFetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    });
  }

  function isCartUi(node) {
    if (!node || !node.closest) return false;
    return !!node.closest(
      '#upCart, #UpcartPopup, #CartPopup, #UpcartPopupBackDrop, .upcart-cart, .t4s-mini-cart, .t4s-mini_cart, .t4s-drawer-cart, .t4s-cart-wrapper, [data-cart-drawer], [class*="upcart" i], [id*="upcart" i]'
    );
  }

  var userAdding = false;

  function cartIsOpen() {
    if (userAdding) return true;
    if (document.body.classList.contains('upcartPopupShow')) return true;
    var drawer = document.getElementById('t4s-mini_cart');
    return !!(drawer && drawer.getAttribute('aria-hidden') === 'false');
  }

  function openUserCart() {
    if (typeof window.upcartOpenCart === 'function') {
      window.upcartOpenCart();
      return;
    }
    var jq = window.jQuery;
    if (jq && window.T4SThemeSP && T4SThemeSP.Drawer && T4SThemeSP.Drawer.opend) {
      T4SThemeSP.Drawer.opend(jq('#t4s-mini_cart'));
      return;
    }
    var link = document.querySelector('.t4s-site-nav__cart a');
    if (link) link.click();
  }

  function pageMarkers() {
    return Array.prototype.filter.call(
      document.querySelectorAll('.t4s-promo-price-data[data-product-id]'),
      function (marker) {
        return !isCartUi(marker);
      }
    );
  }

  function startProbeUi() {
    probing = true;
    document.documentElement.classList.add('t4s-promo-probing');
  }

  function endProbeUi() {
    document.documentElement.classList.remove('t4s-promo-probing');
    probing = false;
  }

  function removeProbeItems(cart) {
    var updates = {};
    ((cart && cart.items) || []).forEach(function (item) {
      if (isProbeItem(item)) updates[item.key] = 0;
    });
    if (!Object.keys(updates).length) return Promise.resolve(cart || {});
    return postJson('/cart/update.js', { updates: updates });
  }

  function getPublicCodes() {
    var list = (window.T4SPromoBoot && window.T4SPromoBoot.publicCodes) || [];
    if (!Array.isArray(list)) list = [list];
    var parts = [];
    list.forEach(function (item) {
      String(item || '')
        .split(/[,;\n]+/)
        .forEach(function (code) {
          parts.push(code);
        });
    });
    return uniqCodes(parts);
  } 

  function appliedCartCodes(cart) {
    if (!cart || !Array.isArray(cart.discount_codes)) return null;
    var fromCart = [];
    cart.discount_codes.forEach(function (d) {
      if (d && d.code && d.applicable !== false) fromCart.push(d.code);
    });
    return uniqCodes(fromCart);
  }

  function writeActiveCode(code) {
    try {
      if (code) sessionStorage.setItem('t4s_promo_active_code', code);
      else sessionStorage.removeItem('t4s_promo_active_code');
    } catch (e) {}
  }

  function getSessionCodes() {
    var boot = (window.T4SPromoBoot && window.T4SPromoBoot.discountCodes) || [];
    var pathCode = codeFromPath();

    return fetchCart()
      .then(function (cart) {
        var fromCart = appliedCartCodes(cart);
        rememberDiscount(cart);
        if (fromCart) {
          var codes = pathCode ? uniqCodes([pathCode].concat(fromCart)) : fromCart;
          writeActiveCode(codes[0] || '');
          return codes;
        }
        return uniqCodes(boot.concat([pathCode]));
      })
      .catch(function () {
        return uniqCodes(boot.concat([pathCode]));
      });
  }

  function pickPromo(pid, publicCodes, sessionCodes, maps, base) {
    var i;
    var code;
    var entry;
    var best = null;
    for (i = 0; i < sessionCodes.length; i++) {
      code = sessionCodes[i];
      entry = maps[code] && maps[code][pid];
      if (entry && entry.ok && entry.final < (entry.original || base)) {
        return { code: code, entry: entry };
      }
    }
    for (i = 0; i < publicCodes.length; i++) {
      code = publicCodes[i];
      entry = maps[code] && maps[code][pid];
      if (!(entry && entry.ok && entry.final < (entry.original || base))) continue;
      if (!best || Number(entry.final) < Number(best.entry.final)) {
        best = { code: code, entry: entry };
      }
    }
    return best;
  }

  var originalDiscount = null;
  var discountTouched = false;
  var lastAppliedDiscount = null;
  var BATCH = 8;

  function visitorDiscount(cart) {
    var pathCode = codeFromPath();
    if (pathCode) return pathCode;
    var fromCart = appliedCartCodes(cart);
    if (fromCart) return fromCart[0] || '';
    if (cart && Array.isArray(cart.discount_codes)) return '';
    return originalDiscount || '';
  }

  function rememberDiscount(cart) {
    if (originalDiscount !== null) return;
    originalDiscount = visitorDiscount(cart);
  }

  function ensureDiscount(code) {
    if (lastAppliedDiscount === code) return Promise.resolve();
    lastAppliedDiscount = code;
    discountTouched = true;
    return postJson('/cart/update.js', { discount: code });
  }

  function restoreDiscount() {
    if (!discountTouched) return Promise.resolve();
    var target = visitorDiscount() || '';
    discountTouched = false;
    if (lastAppliedDiscount === target) return Promise.resolve();
    lastAppliedDiscount = target;
    return postJson('/cart/update.js', { discount: target }).catch(function () {});
  }

  function probeCodes(codes, markers, maps, onUpdate) {
    maps = maps || {};
    return codes.reduce(function (chain, code) {
      return chain.then(function () {
        return probeEligibility(code, markers, function (map) {
          maps[code] = map || maps[code] || {};
          if (onUpdate) onUpdate(maps);
        }).then(function (map) {
          maps[code] = map || {};
          if (onUpdate) onUpdate(maps);
          return maps;
        });
      });
    }, Promise.resolve(maps));
  }

  function allocationMatchesCode(app, code) {
    if (!app) return false;
    var want = String(code || '').toUpperCase().trim();
    var title = app.title ? String(app.title).toUpperCase().trim() : '';
    if (want && title === want) return true;
    var type = app.type ? String(app.type).toLowerCase() : '';
    return type === 'discount_code' && (!title || title === want);
  }

  function codeDiscountCents(item, code) {
    var amount = 0;
    var allocs = item.line_level_discount_allocations || [];
    var sawAlloc = false;
    allocs.forEach(function (a) {
      if (!a) return;
      sawAlloc = true;
      if (!allocationMatchesCode(a.discount_application, code)) return;
      amount += Number(a.amount) || 0;
    });
    if (!sawAlloc && item.discounts) {
      var want = String(code || '').toUpperCase().trim();
      item.discounts.forEach(function (d) {
        var title = d && d.title ? String(d.title).toUpperCase().trim() : '';
        if (want && title === want) amount += Number(d.amount) || 0;
      });
    }
    return amount;
  }

  function pricesForCode(item, code) {
    if (!item) return null;
    var qty = Number(item.quantity) || 1;
    var off = codeDiscountCents(item, code);
    if (!off) return null;
    var originalLine =
      item.original_line_price != null
        ? Number(item.original_line_price)
        : Number(item.original_price != null ? item.original_price : item.price) * qty;
    if (!originalLine || off <= 0) return null;
    var original = Math.round(originalLine / qty);
    var finalPrice = Math.max(0, Math.round((originalLine - off) / qty));
    if (!(finalPrice < original)) return null;
    return { ok: true, final: finalPrice, original: original };
  }

  function isProbeItem(item) {
    var props = item && item.properties;
    if (!props) return false;
    if (Array.isArray(props)) {
      return props.some(function (prop) {
        if (!prop) return false;
        var name = prop.name || prop.first || prop[0];
        return name === '_t4s_probe';
      });
    }
    return !!(props._t4s_probe || props['_t4s_probe']);
  }

  var ignoreCartEvents = false;

  function sweepProbeItems() {
    return fetchCart()
      .then(function (cart) {
        if (!((cart && cart.items) || []).some(isProbeItem)) return cart;
        ignoreCartEvents = true;
        return removeProbeItems(cart).then(function (next) {
          setTimeout(function () {
            ignoreCartEvents = false;
          }, 1000);
          return next;
        });
      })
      .catch(function () {});
  }

  function hideProbeLines() {
    var nodes = document.body ? document.body.querySelectorAll('*') : [];
    Array.prototype.forEach.call(nodes, function (el) {
      if (!el || el.children.length) return;
      if ((el.textContent || '').indexOf('_t4s_probe') === -1) return;
      var line = el.parentElement;
      var depth = 0;
      while (line && depth < 10) {
        if (line.querySelector('img') && (line.querySelector('button') || line.querySelector('input'))) {
          line.style.setProperty('display', 'none', 'important');
          return;
        }
        line = line.parentElement;
        depth += 1;
      }
    });
  }

  function markerInView(marker) {
    var price = findPriceEl(marker) || marker;
    var rect = price.getBoundingClientRect();
    return rect.bottom > -200 && rect.top < window.innerHeight + 400;
  }

  function removeAdded(items) {
    var updates = {};
    (items || []).forEach(function (item) {
      if (item && item.key) updates[item.key] = 0;
    });
    if (!Object.keys(updates).length) return Promise.resolve();
    return postJson('/cart/update.js', { updates: updates });
  }

  function probeEligibility(code, markers, onUpdate) {
    if (window.Shopify && window.Shopify.designMode) {
      return Promise.resolve(readCache(code));
    }

    var map = readCache(code);
    var needed = [];
    var seen = {};

    markers.forEach(function (marker) {
      var pid = marker.getAttribute('data-product-id');
      var vid = marker.getAttribute('data-variant-id');
      var available = marker.getAttribute('data-available') !== 'false';
      if (!pid || !vid || !available) return;
      if (Object.prototype.hasOwnProperty.call(map, pid)) return;
      if (seen[vid]) return;
      seen[vid] = true;
      needed.push({ pid: pid, vid: Number(vid), view: markerInView(marker) });
    });

    needed.sort(function (a, b) {
      return (a.view ? 0 : 1) - (b.view ? 0 : 1);
    });

    if (cartIsOpen() || !needed.length) {
      return sweepProbeItems().then(function () {
        return map;
      });
    }

    if (probePromise) {
      return probePromise.then(function () {
        return probeEligibility(code, markers, onUpdate);
      });
    }

    function rememberAdded(added, chunk) {
      var matched = {};
      (added || []).forEach(function (item) {
        var pid = String(item.product_id || '');
        if (!pid) return;
        var priced = pricesForCode(item, code);
        map[pid] = priced || { ok: false };
        matched[pid] = true;
      });
      if (!added || !added.length) return;
      chunk.forEach(function (row) {
        if (!matched[row.pid] && !Object.prototype.hasOwnProperty.call(map, row.pid)) {
          map[row.pid] = { ok: false };
        }
      });
      writeCache(code, map);
      if (onUpdate) onUpdate(map);
    }

    function addBatch(chunk, attempt) {
      if (!chunk.length || cartIsOpen()) return Promise.resolve();
      var items = chunk.map(function (row) {
        return {
          id: row.vid,
          quantity: 1,
          properties: { _t4s_probe: code }
        };
      });
      return postJson('/cart/add.js', { items: items }).then(function (res) {
        var added = res && res.items ? res.items : [];
        if (!res || res.__ok === false || res.status === 422) {
          if ((res && res.__status >= 500) || (res && res.__status === 429)) {
            if (attempt >= 2) return Promise.resolve();
            return new Promise(function (resolve) {
              setTimeout(resolve, 500);
            }).then(function () {
              return addBatch(chunk, attempt + 1);
            });
          }
          if (chunk.length > 1) {
            var mid = Math.ceil(chunk.length / 2);
            return addBatch(chunk.slice(0, mid), 0).then(function () {
              return addBatch(chunk.slice(mid), 0);
            });
          }
          map[chunk[0].pid] = { ok: false };
          writeCache(code, map);
          if (onUpdate) onUpdate(map);
          return Promise.resolve();
        }
        rememberAdded(added, chunk);
        return fetchCart().then(removeProbeItems).catch(function () {
          return removeAdded(added);
        });
      });
    }

    var chunks = [];
    for (var i = 0; i < needed.length; i += BATCH) {
      chunks.push(needed.slice(i, i + BATCH));
    }

    startProbeUi();
    probePromise = fetchCart()
      .then(function (cart) {
        rememberDiscount(cart);
        return removeProbeItems(cart);
      })
      .then(function () {
        if (cartIsOpen()) return;
        return ensureDiscount(code);
      })
      .then(function () {
        return chunks.reduce(function (chain, chunk) {
          return chain.then(function () {
            if (cartIsOpen()) return;
            return addBatch(chunk, 0);
          });
        }, Promise.resolve());
      })
      .then(function () {
        return sweepProbeItems();
      })
      .then(function () {
        probePromise = null;
        endProbeUi();
        hideProbeLines();
        return map;
      })
      .catch(function () {
        probePromise = null;
        return fetchCart()
          .then(removeProbeItems)
          .catch(function () {
            return {};
          })
          .then(function () {
            endProbeUi();
            hideProbeLines();
            return map;
          });
      });

    return probePromise;
  }

  function findPriceEl(marker) {
    var root =
      marker.closest('.t4s-product-info__inner') ||
      marker.closest('.t4s-product-info') ||
      marker.closest('.t4s-product__info') ||
      marker.closest('.t4s-product__price-review') ||
      marker.closest('.t4s-product') ||
      marker.parentElement;

    if (!root) return null;
    return (
      root.querySelector('.t4s-product-price') ||
      root.querySelector('[data-product-price]') ||
      root.querySelector('[data-pr-price]')
    );
  }

  function findPromoRow(priceEl) {
    if (!priceEl) return null;
    var uid = priceEl.dataset.t4sPromoUid;
    if (uid) {
      var byUid = document.querySelector('.t4s-promo-row[data-for-price="' + uid + '"]');
      if (byUid) return byUid;
    }
    var next = priceEl.nextElementSibling;
    if (next && next.classList.contains('t4s-promo-row')) return next;
    var stock = priceEl.closest('.t4s-price-stock');
    if (stock) {
      var inside = stock.querySelector('.t4s-promo-row');
      if (inside) return inside;
    }
    return null;
  }

  function promoRowPlacedCorrectly(priceEl, row) {
    if (!priceEl || !row) return false;
    var stock = priceEl.closest('.t4s-price-stock');
    // On product page: promo sits inside the price row, right after the theme price
    if (stock) {
      return row.parentElement === stock && priceEl.nextElementSibling === row;
    }
    return row.previousElementSibling === priceEl;
  }

  function removePromoRows(priceEl) {
    if (!priceEl) return;
    var uid = priceEl.dataset.t4sPromoUid;
    if (uid) {
      document.querySelectorAll('.t4s-promo-row[data-for-price="' + uid + '"]').forEach(function (el) {
        el.remove();
      });
    }
    var stock = priceEl.closest('.t4s-price-stock');
    if (stock) {
      Array.prototype.slice.call(stock.querySelectorAll('.t4s-promo-row')).forEach(function (el) {
        el.remove();
      });
      if (stock.nextElementSibling && stock.nextElementSibling.classList.contains('t4s-promo-row')) {
        stock.nextElementSibling.remove();
      }
    }
    if (priceEl.nextElementSibling && priceEl.nextElementSibling.classList.contains('t4s-promo-row')) {
      priceEl.nextElementSibling.remove();
    }
  }

  function promoRowHtml(promoCents, code, uid) {
    return (
      '<div class="t4s-promo-row" data-for-price="' +
      (uid || '') +
      '" aria-label="Price with promo code">' +
      '<ins class="t4s-promo-final">' +
      formatMoney(promoCents) +
      '</ins> ' +
      '<span class="t4s-promo-code-note">' +
      '<span class="t4s-promo-code-note__label">With code</span> ' +
      '<span class="t4s-promo-code-note__value">' +
      code +
      '</span></span></div>'
    );
  }

  function clearPromo(priceEl) {
    if (!priceEl) return;
    if (priceEl.dataset.t4sPromoOriginalHtml) {
      priceEl.innerHTML = priceEl.dataset.t4sPromoOriginalHtml;
      delete priceEl.dataset.t4sPromoOriginalHtml;
    }
    priceEl.classList.remove('is-promo-active');
    delete priceEl.dataset.t4sPromoApplied;
    removePromoRows(priceEl);
  }

  function applyPromo(marker, code, map) {
    if (marker.closest('.t4s-grouped-product-list')) return;
    var priceEl = findPriceEl(marker);
    var pid = marker.getAttribute('data-product-id');
    var base = parseInt(marker.getAttribute('data-base-price'), 10);
    if (!priceEl || !pid) return;

    // Restore theme price if a previous version replaced it
    if (priceEl.dataset.t4sPromoOriginalHtml && priceEl.querySelector('.t4s-promo-final, .t4s-promo-base, .t4s-promo-with')) {
      priceEl.innerHTML = priceEl.dataset.t4sPromoOriginalHtml;
    }
    if (!priceEl.dataset.t4sPromoOriginalHtml) {
      priceEl.dataset.t4sPromoOriginalHtml = priceEl.innerHTML;
    }
    if (!priceEl.dataset.t4sPromoUid) {
      priceEl.dataset.t4sPromoUid = 'p' + pid + '-' + Math.random().toString(36).slice(2, 7);
    }

    var entry = map[pid];
    var active = !!(code && entry && entry.ok && entry.final < (entry.original || base));
    if (!active) {
      clearPromo(priceEl);
      return;
    }

    var promoCents = Number(entry.final);
    var stateKey = code + ':' + promoCents;
    var existing = findPromoRow(priceEl);
    if (priceEl.dataset.t4sPromoApplied === stateKey && promoRowPlacedCorrectly(priceEl, existing)) {
      return;
    }

    priceEl.classList.add('is-promo-active');
    priceEl.dataset.t4sPromoApplied = stateKey;
    removePromoRows(priceEl);
    // Keep promo on the same price row (above border), right after theme price
    priceEl.insertAdjacentHTML('afterend', promoRowHtml(promoCents, code, priceEl.dataset.t4sPromoUid));
  }

  function groupedUnitPrice(sl, entry) {
    var orig = parseInt(sl.dataset.t4sOrigPrice || sl.getAttribute('data-price'), 10);
    if (isNaN(orig)) return 0;
    if (entry && entry.ok) return Number(entry.final);
    return orig;
  }

  function updateGroupedFieldPrice(sl, entry) {
    if (!sl.dataset.t4sOrigPrice) sl.dataset.t4sOrigPrice = sl.getAttribute('data-price') || '0';
    sl.querySelectorAll('option[data-price]').forEach(function (opt) {
      if (!opt.dataset.t4sOrigPrice) opt.dataset.t4sOrigPrice = opt.getAttribute('data-price') || '0';
      var orig = parseInt(opt.dataset.t4sOrigPrice, 10);
      if (isNaN(orig)) return;
      var price = orig;
      if (entry && entry.ok && entry.original) {
        price = Math.round(orig * (Number(entry.final) / Number(entry.original)));
      }
      opt.setAttribute('data-price', price);
    });
  }

  function applyGroupedFromMaps() {
    var flat = {};
    var code = '';
    document.querySelectorAll('[data-groups-pr-item][data-product-id]').forEach(function (row) {
      var pid = row.getAttribute('data-product-id');
      var picked = pickPromo(pid, lastPublicCodes, lastSessionCodes, lastMaps, 0);
      if (!picked) return;
      flat[pid] = picked.entry;
      code = picked.code;
    });
    lastPromoCode = code;
    lastPromoMap = flat;
    applyGroupedPromos(code, flat);
  }

  function applyGroupedPromos(code, map) {
    document.querySelectorAll('[data-groups-pr-form]').forEach(function (form) {
      var total = 0;
      var compare = 0;
      form.querySelectorAll('[data-groups-pr-item]').forEach(function (row) {
        var sl = row.querySelector('[data-groups-pr-sl]');
        var qtyEl = row.querySelector('[data-groups-qty-value]');
        var priceEl = row.querySelector('[data-groups-item-price]');
        if (!sl) return;
        var pid = row.getAttribute('data-product-id');
        var entry = pid && map ? map[pid] : null;
        var selected = sl.tagName === 'SELECT' ? sl.options[sl.selectedIndex] : sl;
        if (selected && !selected.dataset.t4sOrigPrice && selected.getAttribute('data-price')) {
          selected.dataset.t4sOrigPrice = selected.getAttribute('data-price');
        }
        if (!sl.dataset.t4sOrigPrice) {
          sl.dataset.t4sOrigPrice = (selected && selected.dataset.t4sOrigPrice) || sl.getAttribute('data-price') || '0';
        }
        updateGroupedFieldPrice(sl, entry);
        var unit = groupedUnitPrice(selected || sl, entry);
        sl.setAttribute('data-price', unit);
        var orig = Number(entry && entry.original) || parseInt((selected && selected.dataset.t4sOrigPrice) || sl.dataset.t4sOrigPrice || unit, 10);
        var qty = parseInt(qtyEl && qtyEl.value, 10) || 0;
        if (priceEl) {
          if (!priceEl.dataset.t4sGroupedOrigHtml) priceEl.dataset.t4sGroupedOrigHtml = priceEl.innerHTML;
          if (entry && entry.ok && unit < orig) {
            priceEl.innerHTML = '<del>' + formatMoney(orig) + '</del> <ins>' + formatMoney(unit) + '</ins>';
          } else {
            priceEl.innerHTML = priceEl.dataset.t4sGroupedOrigHtml;
          }
        }
        if (qty > 0) {
          total += unit * qty;
          compare += orig * qty;
        }
      });
      var totalEl = form.querySelector('[data-groups-total-price]');
      if (!totalEl) return;
      if (!totalEl.dataset.t4sGroupedOrigHtml) totalEl.dataset.t4sGroupedOrigHtml = totalEl.innerHTML;
      if (total <= 0) {
        totalEl.innerHTML = formatMoney(0);
      } else if (code && total < compare) {
        totalEl.innerHTML = '<del>' + formatMoney(compare) + '</del> <ins>' + formatMoney(total) + '</ins>';
      } else {
        totalEl.innerHTML = formatMoney(total);
      }
    });
  }

  var lastPromoCode = '';
  var lastPromoMap = {};
  var lastPublicCodes = [];
  var lastSessionCodes = [];
  var lastMaps = {};

  function showDiscountToast(codes) {
    if (!codes || !codes.length) return;
    var code = codes[0];
    var key = 't4s_promo_toast_' + code;
    try {
      if (sessionStorage.getItem(key)) return;
      sessionStorage.setItem(key, '1');
    } catch (e) {}

    var existing = document.querySelector('.t4s-promo-toast');
    if (existing) existing.remove();

    var el = document.createElement('div');
    el.className = 't4s-promo-toast';
    el.setAttribute('role', 'status');
    el.innerHTML =
      '<strong>Discount applied:</strong> <span>' +
      code +
      '</span> — sale prices are shown on products this code applies to.' +
      '<button type="button" class="t4s-promo-toast__close" aria-label="Close">&times;</button>';
    document.body.appendChild(el);

    requestAnimationFrame(function () {
      el.classList.add('is-visible');
    });

    var close = function () {
      el.classList.remove('is-visible');
      setTimeout(function () {
        if (el.parentNode) el.parentNode.removeChild(el);
      }, 300);
    };
    el.querySelector('.t4s-promo-toast__close').addEventListener('click', close);
    setTimeout(close, 8000);
  }

  function cachedMaps(codes) {
    var maps = {};
    (codes || []).forEach(function (code) {
      maps[code] = readCache(code);
    });
    return maps;
  }

  function sessionCovered(pid, sessionCodes, maps, base) {
    return !!pickPromo(pid, [], sessionCodes, maps, base);
  }

  function paintMarkers(markers, publicCodes, sessionCodes, maps) {
    lastMaps = maps || {};
    lastPublicCodes = publicCodes;
    lastSessionCodes = sessionCodes;
    markers.forEach(function (marker) {
      var pid = marker.getAttribute('data-product-id');
      var base = parseInt(marker.getAttribute('data-base-price'), 10);
      var picked = pickPromo(pid, publicCodes, sessionCodes, lastMaps, base);
      if (!picked) {
        applyPromo(marker, '', {});
        return;
      }
      var one = {};
      one[pid] = picked.entry;
      applyPromo(marker, picked.code, one);
    });
    applyGroupedFromMaps();
  }

  function syncSessionCodes() {
    var boot = (window.T4SPromoBoot && window.T4SPromoBoot.discountCodes) || [];
    return uniqCodes(boot.concat([codeFromPath()]));
  }

  function refresh() {
    var markers = pageMarkers();
    if (!markers.length) return;

    var publicCodes = getPublicCodes();
    var earlySession = syncSessionCodes();
    if (earlySession.length || publicCodes.length) {
      paintMarkers(
        markers,
        publicCodes,
        earlySession,
        cachedMaps(uniqCodes(earlySession.concat(publicCodes)))
      );
    }

    getSessionCodes().then(function (sessionCodes) {
      var codes = uniqCodes(sessionCodes.concat(publicCodes));
      lastPublicCodes = publicCodes;
      lastSessionCodes = sessionCodes;

      if (!codes.length) {
        markers.forEach(function (marker) {
          var priceEl = findPriceEl(marker);
          if (priceEl) clearPromo(priceEl);
        });
        lastPromoCode = '';
        lastPromoMap = {};
        lastMaps = {};
        applyGroupedPromos('', {});
        return;
      }

      if (sessionCodes.length) showDiscountToast(sessionCodes);
      var maps = cachedMaps(codes);
      paintMarkers(markers, publicCodes, sessionCodes, maps);

      return probeCodes(sessionCodes, markers, maps, function () {
        paintMarkers(markers, publicCodes, sessionCodes, maps);
      })
        .then(function () {
          var rest = markers.filter(function (marker) {
            var pid = marker.getAttribute('data-product-id');
            var base = parseInt(marker.getAttribute('data-base-price'), 10);
            return !sessionCovered(pid, sessionCodes, maps, base);
          });
          if (!rest.length || !publicCodes.length) return maps;
          return probeCodes(publicCodes, rest, maps, function () {
            paintMarkers(markers, publicCodes, sessionCodes, maps);
          });
        })
        .then(function () {
          return restoreDiscount(visitorDiscount());
        });
    });
  }

  function boot() {
    sweepProbeItems().then(hideProbeLines);
    refresh();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('change', function (e) {
    if (!e.target || !e.target.closest) return;
    if (!e.target.closest('[data-groups-pr-form]')) return;
    if (!e.target.matches('[data-groups-qty-value], [data-groups-pr-sl], [data-quantity-value]')) return;
    applyGroupedFromMaps();
  });
  document.addEventListener('input', function (e) {
    if (!e.target || !e.target.closest) return;
    if (!e.target.closest('[data-groups-pr-form]')) return;
    if (!e.target.matches('[data-groups-qty-value], [data-quantity-value]')) return;
    applyGroupedFromMaps();
  });
  document.addEventListener(
    'click',
    function (e) {
      var btn =
        e.target &&
        e.target.closest &&
        e.target.closest('[data-atc-form], [data-action-atc], button[name="add"]');
      if (!btn) return;
      if (btn.closest('#upCart, .t4s-mini_cart, [class*="upcart" i]')) return;
      userAdding = true;
      setTimeout(function () {
        var drawer = document.getElementById('t4s-mini_cart');
        var themeOpen = drawer && drawer.getAttribute('aria-hidden') === 'false';
        if (!document.body.classList.contains('upcartPopupShow') && !themeOpen) openUserCart();
        userAdding = false;
      }, 700);
    },
    true
  );

  function bindCartOpen() {
    var jq = window.jQuery;
    if (!jq) {
      setTimeout(bindCartOpen, 200);
      return;
    }
    jq(document).on('add:cart:success', function () {
      userAdding = false;
      setTimeout(openUserCart, 40);
    });
  }
  bindCartOpen();

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    if (!e.target.closest('[data-groups-pr-form] [data-quantity-selector]')) return;
    setTimeout(function () {
      applyGroupedFromMaps();
    }, 50);
  });
  document.addEventListener('cart:updated', function () {
    if (probing || ignoreCartEvents) return;
    setTimeout(function () {
      sweepProbeItems().then(hideProbeLines);
      refresh();
    }, 300);
  });

  var obsTimer = null;
  var obs = new MutationObserver(function (mutations) {
    var hasNew = mutations.some(function (m) {
      return Array.prototype.some.call(m.addedNodes || [], function (node) {
        if (node.nodeType !== 1) return false;
        if (isCartUi(node)) return false;
        return (
          (node.matches && node.matches('.t4s-promo-price-data[data-product-id]')) ||
          (node.querySelector && node.querySelector('.t4s-promo-price-data[data-product-id]'))
        );
      });
    });
    if (!hasNew) return;
    clearTimeout(obsTimer);
    obsTimer = setTimeout(function () {
      hideProbeLines();
      refresh();
    }, 250);
  });

  if (document.body) {
    obs.observe(document.body, { childList: true, subtree: true });
  }
})();
